import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { BulkAction } from 'src/app/shared/interfaces'

import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core'
import { DataTable } from '@pascalhonegger/ng-datatable'

import { Raffle } from '../raffle'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'
import { Observable, Subject } from 'rxjs'
import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { Dictionary } from '@ngrx/entity'
import { Course } from '../../course/course'
import { courseSelectors } from '../../course/course.selectors'
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy'
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators'
import { raffleActions } from '../raffle.actions'
import DEBOUNCED_TIME = Constants.DEBOUNCED_TIME
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { Constants } from 'src/app/shared/constants'
@UntilDestroy()
@Component({
  selector: 'raffle-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class RaffleTableComponent {
  @Input() tableData: Raffle[]
  @Input() bulkActions: BulkAction[] = [BulkAction.DELETE]
  @Output() onBulkAction = new EventEmitter<any>()
  @Output() onClickRow = new EventEmitter<any>()
  @Output() onSelectedPage = new EventEmitter<any>()
  @Output() onSelectLimit = new EventEmitter<any>()
  @Output() onSearchTerm = new EventEmitter<any>()
  @Output() onSortedTable = new EventEmitter<any>()
  @Input() showPageFooter: boolean = false
  @Input() removeSearchTerm$: Observable<boolean>
  @Input() total: number
  @Input() showTotal = false
  @Input() pageCount: number
  @Input() activePage: number = 1
  @Input() limitPage: number = 10
  @Input() key = 'id'
  @Input() sortOrder
  @ViewChild('dataTable', { static: true }) dataTable: DataTable

  public filterTerm: string = ''
  public allCheckedToggle: boolean = false
  public checkedIds: Map<number, boolean> = new Map()
  public sortingField = 'registrationStartDate_desc'
  public selectedLanguage$: Observable<string>
  public searchTerm$ = new Subject<string>()
  public courseEntities$: Observable<Dictionary<Course>>
  public accessRights = AccessRights

  constructor(
    private store: Store<AppState>,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )
    this.courseEntities$ = this.store.select(courseSelectors.selectEntities)
    this.removeSearchTerm$?.pipe(untilDestroyed(this)).subscribe((remove) => {
      if (remove) {
        this.filterTerm = ''
      }
    })
    this.searchTerm$
      .pipe(
        distinctUntilChanged(),
        debounceTime(DEBOUNCED_TIME),
        untilDestroyed(this),
        filter((s) => s.length > 2)
      )
      .subscribe((term) => {
        this.store.dispatch(
          raffleActions.fetchMany({
            params: RequestQueryBuilder.create({
              search: {
                'course.description': {
                  [CondOperator.CONTAINS_LOW]: term
                }
              },
              join: [{ field: 'course' }]
            })
          })
        )
      })
  }

  public onRowClicked(row: Raffle) {
    this.onClickRow.emit(row)
  }

  public onCheckRow(targetRow: Raffle) {
    this.checkedIds.set(
      targetRow.id,
      !Boolean(this.checkedIds.get(targetRow.id))
    )
  }

  public onToggleAllChecked() {
    this.allCheckedToggle = !this.allCheckedToggle

    this.dataTable.data.forEach((row) =>
      this.checkedIds.set(row.id, this.allCheckedToggle)
    )
  }
  public getCourseDescription(courseEntitites, raffle) {
    if (courseEntitites[raffle.courseId]) {
      return courseEntitites[raffle.courseId].description
    }
    return raffle.course?.description
  }
  public onClickBulkAction(bulkOption: string) {
    const rows: Raffle[] = this.dataTable.data.filter((x) =>
      this.checkedIds.get(x.id)
    )

    if (rows.length > 0) {
      this.onBulkAction.emit({ action: bulkOption, items: rows })
    }
  }
  public selectPage(event) {
    this.onSelectedPage.emit(event)
  }
  public setNewSearch(event) {
    console.log(event)
  }
  public onSearch(value) {
    if (this.showPageFooter) {
      this.onSearchTerm.emit(value)
    } else {
      this.searchTerm$.next(value)
    }
  }
  public setSearchLimit(event) {
    this.onSelectLimit.emit(event)
  }

  public onSortfieldClick(fieldName: string) {
    this.sortingField =
      this.sortingField == `${fieldName}_asc`
        ? `${fieldName}_desc`
        : `${fieldName}_asc`
    if (this.showPageFooter) {
      this.onSortedTable.emit(this.sortingField)
    }
  }
}
